import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UtilService } from './services/util.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
	imports: [RouterOutlet],
})
export class AppComponent {
	private utilService = inject(UtilService);

	constructor() {
		this.utilService.registerSlashIcon();
		this.utilService.startObservingSize();
	}
}
